import { render, staticRenderFns } from "./WaterDissolutionDma.vue?vue&type=template&id=837532de&scoped=true&"
import script from "./WaterDissolutionDma.vue?vue&type=script&lang=js&"
export * from "./WaterDissolutionDma.vue?vue&type=script&lang=js&"
import style0 from "./WaterDissolutionDma.vue?vue&type=style&index=0&id=837532de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837532de",
  null
  
)

export default component.exports